var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1690",
    "data-name": "Rectangle 1690",
    width: 100,
    height: 99,
    transform: "translate(-0.184 -0.127)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Options_Icon",
    transform: "translate(0.184 0.127)",
    opacity: 0.5,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Options_Icon-2",
    "data-name": "Options_Icon",
    transform: "translate(15.084 9.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13431",
    "data-name": "Path 13431",
    d: "M45.241,12.093,34.709,19.472a1.709,1.709,0,1,0,1.97,2.794l6.86-4.8V36.183a1.719,1.719,0,0,0,3.439,0v-18.7l6.86,4.8a1.715,1.715,0,0,0,2.382-.43,1.716,1.716,0,0,0-.412-2.382L45.277,12.093Z",
    transform: "translate(-11.067 -12.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13432",
    "data-name": "Path 13432",
    d: "M38.286,39.012l-16.21-9.368L29.652,26.1A1.711,1.711,0,1,0,28.2,23L16.559,28.427,17.67,41.233a1.7,1.7,0,0,0,1.7,1.558h.143a1.711,1.711,0,0,0,1.558-1.863L20.339,32.6l16.21,9.368a1.634,1.634,0,0,0,.86.233,1.719,1.719,0,0,0,.86-3.206Z",
    transform: "translate(-16.559 -8.707)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13433",
    "data-name": "Path 13433",
    d: "M36.58,47.017,20.37,56.385l.734-8.329a1.717,1.717,0,1,0-3.421-.3L16.573,60.558l11.642,5.427a1.711,1.711,0,0,0,2.275-.824,1.71,1.71,0,0,0-.824-2.275L22.09,59.34,38.3,49.973A1.717,1.717,0,0,0,36.58,47Z",
    transform: "translate(-16.555 -1.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13434",
    "data-name": "Path 13434",
    d: "M53.823,68.106l-6.86,4.8V54.189a1.719,1.719,0,0,0-3.439,0V72.906l-6.86-4.8a1.709,1.709,0,0,0-1.97,2.794L45.226,78.28,55.758,70.9a1.709,1.709,0,0,0-1.97-2.794Z",
    transform: "translate(-11.069 0.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13435",
    "data-name": "Path 13435",
    d: "M70.964,46.178a1.711,1.711,0,0,0-1.558,1.863l.734,8.329L53.931,47a1.717,1.717,0,1,0-1.719,2.973l16.21,9.368-7.576,3.546a1.711,1.711,0,0,0,.734,3.26,1.673,1.673,0,0,0,.716-.161l11.642-5.427-1.11-12.807A1.711,1.711,0,0,0,70.964,46.2Z",
    transform: "translate(-5.588 -1.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13436",
    "data-name": "Path 13436",
    d: "M53.075,42.2a1.679,1.679,0,0,0,.86-.233L70.145,32.6l-.734,8.329a1.711,1.711,0,0,0,1.558,1.863h.143a1.713,1.713,0,0,0,1.7-1.558l1.111-12.807L62.282,23a1.711,1.711,0,1,0-1.451,3.1l7.576,3.546L52.2,39.011a1.719,1.719,0,0,0,.86,3.206Z",
    transform: "translate(-5.592 -8.705)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionsIcon);
export default __webpack_public_path__ + "static/media/Options_Icon.4b37ed1afe0c552b8bdc177f363ca7d7.svg";
export { ForwardRef as ReactComponent };